import React from 'react';

import makeStyles from '@mui/styles/makeStyles';

import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';

import Stop from '@mui/icons-material/Stop';

interface StopIconProps {
  onClick: () => void;
}

const useStyles = makeStyles(
  {
    iconContainerBottom: {
      position: 'absolute',
      top: '90%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      color: '#EEE',
    },
  },
  { name: 'VCStopIcon' },
);

const StopIcon: React.FC<StopIconProps> = ({ onClick }) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.iconContainerBottom}>
        <IconButton onClick={onClick} size="large">
          <CircularProgress style={{ color: 'white' }} variant="determinate" value={100} />
        </IconButton>
      </div>
      <div className={classes.iconContainerBottom}>
        <IconButton onClick={onClick} size="large">
          <Stop fontSize="large" htmlColor="red" />
        </IconButton>
      </div>
    </>
  );
};

export default StopIcon;
